export const formatNumber = (value, decimals = 0) => {
  if (!value && value !== 0) return '0';
  
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  
  if (isNaN(numValue)) return '0';
  
  if (decimals === 0) {
    return Math.round(numValue).toString();
  }
  
  return numValue.toFixed(decimals);
};

export const formatCurrency = (value) => {
  if (!value && value !== 0) return 'R$ 0,00';
  
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  
  if (isNaN(numValue)) return 'R$ 0,00';
  
  return `R$ ${numValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}; 